export const STUFF_TO_EAT_ADVANCED_CATEGORISATION = 'stuff_to_eat_advanced_categorisation';



// WEBPACK FOOTER //
// ./src/constants/stuff-to-eat-category.js